import { getValues } from './types'

type MatchingItem = Record<string, unknown>

export const getRegexSafeString = (string: string) =>
  string.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1')

export const getQueryFilter = <T extends MatchingItem>(
  query: string | undefined = '',
  stringMatcher = (item: T) => getValues(item)
) => {
  if (!query) return () => true

  const exactMatchRegex = /"([^"]+)"|(\S+)/g
  const keyWords = Array.from(query.matchAll(exactMatchRegex), match => match[1] || match[2])

  return (item: T) =>
    keyWords.every((keyWord: string) => {
      if (keyWord.startsWith('"') && keyWord.endsWith('"')) {
        // Exact match
        const exactPhrase = keyWord.slice(1, -1)
        return stringMatcher(item).forEach(itemAttr => String(itemAttr).includes(exactPhrase))
      } else {
        // Regular search
        const regexSafeKeyWord = getRegexSafeString(keyWord)
        const test = stringMatcher(item).join('').match(new RegExp(regexSafeKeyWord, 'i'))
        return test
      }
    })
}
